import Header from "../Header/Header";

const SparePage = (props) => {

  //Props
  const IsDesktop = props.isDesktop;

  
  return (
    <div>
      <Header isDesktop={IsDesktop} />
      <div style={{display: "flex", height: "100px", justifyContent: "center", alignItems: "center"}}>
        Spare parts - Under construction
      </div>
    </div>
  )

};

export default SparePage;